// Mock data for portfolio website

export const personalInfo = {
  name: "Irfan Ansari",
  title: "Full Stack Developer + AI Enthusiast",
  tagline: "Building digital experiences that matter",
  bio: "Passionate full-stack developer and AI Enthusiast creating scalable web applications. I specialize in building modern, user-centric solutions using cutting-edge technologies. When I'm not coding, you'll find me contributing to open-source projects or exploring the latest tech trends.",
  email: "irfan8318450619@gmail.com",
  location: "Lucknow, India",
  image: "/images/Background-image.jpg",
  resume: "/resume.pdf",
  social: {
    github: "https://github.com/irfan-ansari303",
    linkedin: "https://www.linkedin.com/in/irfanansari8318/",
    twitter: "https://x.com/ansari_irf94136",
  }
};

export const skills = {
  frontend: [
    { name: "React", level: 95, icon: "⚛️" },
    { name: "Next.js", level: 90, icon: "▲" },
    { name: "Tailwind CSS", level: 92, icon: "🎨" },
    { name: "JavaScript", level: 95, icon: "JS" },
    { name: "HTML5/CSS3", level: 98, icon: "HTML" },
  ],
  backend: [
    { name: "Node.js", level: 90, icon: "Node" },
    { name: "MYSQL", level: 85, icon: "SQL" },
    { name: "RestAPI", level: 82, icon: "⚡" },
    { name: "Express", level: 88, icon: "Express" },
    { name: "MongoDB", level: 86, icon: "🍃" },
    { name: "PostgreSQL", level: 84, icon: "🐘" },
  ],
  tools: [
    { name: "Git", level: 92, icon: "Git" },
    { name: "Docker", level: 80, icon: "🐳" },
    { name: "AWS", level: 75, icon: "☁️" },
    { name: "VS Code", level: 95, icon: "VS" },
    { name: "Postman", level: 88, icon: "📮" },
  ]
};

export const projects = [
  {
    id: 1,
    title: "Talent IQ - Coding Interview Platform",
    description: "Developed a full stack coding interview platform enabling real time interview practice.",
    image: "https://images.unsplash.com/photo-1553877522-43269d4ea984?w=800&h=500&fit=crop",
    tech: ["React", "Node.js", "TanStack Query", "WebRTC", "MongoDB"],
    github: "https://github.com/irfan-ansari303/TALENT-IQ.git",
    live: "https://talent-iq-1-io9l.onrender.com",
    category: "fullstack"
  },
  {
    id: 2,
    title: "URL Shortener",
    description: "A full stack project of shortner URL.",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=500&fit=crop",
    tech: ["Node.js","MongoDB"],
    github: "https://github.com/irfan-ansari303/URL_SHORTNER.git",
    live: "https://url-shortner-037m.onrender.com",
    category: "backend"
  },
  {
    id: 3,
    title: "AIris Chat Assistant",
    description: "Built an AI powered chat assistant with real time LLM integration.",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=500&fit=crop",
    tech: ["HTML", "Tailwind CSS", "React.js", "Gemini API"],
    github: "https://github.com/irfan-ansari303/AIris-chat-boat.git",
    live: "https://airis-chat-bot.vercel.app/",
    category: "frontend"
  },
  // {
  //   id: 4,
  //   title: "Social Media Analytics",
  //   description: "Data visualization platform for social media metrics with predictive analytics and automated reporting features.",
  //   image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=500&fit=crop",
  //   tech: ["React", "D3.js", "Python", "Pandas", "AWS"],
  //   github: "https://github.com",
  //   live: "https://example.com",
  //   category: "fullstack"
  // }
];

export const experience = [
  {
    id: 1,
    company: "Tech Innovations Inc.",
    role: "Senior Full Stack Developer",
    duration: "2022 - Present",
    description: "Led development of cloud-based SaaS platform serving 50K+ users. Architected microservices infrastructure and mentored junior developers.",
    logo: "https://images.unsplash.com/photo-1549923746-c502d488b3ea?w=100&h=100&fit=crop"
  },
  {
    id: 2,
    company: "Digital Solutions Co.",
    role: "Full Stack Developer",
    duration: "2020 - 2022",
    description: "Built and maintained multiple client projects using React and Node.js. Improved application performance by 40% through optimization.",
    logo: "https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=100&h=100&fit=crop"
  },
  {
    id: 3,
    company: "StartUp Ventures",
    role: "Frontend Developer",
    duration: "2019 - 2020",
    description: "Developed responsive web applications and collaborated with UX designers to create intuitive user interfaces.",
    logo: "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=100&h=100&fit=crop"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    role: "Product Manager at Tech Co.",
    content: "Alex is an exceptional developer who consistently delivers high-quality work. His attention to detail and problem-solving skills are outstanding.",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop"
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "CTO at StartUp Inc.",
    content: "Working with Alex was a game-changer for our project. His technical expertise and ability to translate complex requirements into elegant solutions is remarkable.",
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop"
  }
];